import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
export default (function () {
    return getFallbackValueIfNull(getStore().newMailToast, !!(getUserConfiguration().UserOptions.NewItemNotify & 2 /* EMailToast */));
});
//# sourceMappingURL=isNewMailToastEnabled.js.map